module.exports = __webpack_public_path__ + "static/media/venues.11a5b52f.svg";